import { 
  getAuth, 
  sendSignInLinkToEmail, 
  isSignInWithEmailLink, 
  signInWithEmailLink, 
  onAuthStateChanged, 
  signOut,
  updateProfile,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  updateEmail,
  updatePassword,
  sendPasswordResetEmail,
  sendEmailVerification,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";

import app, {baseUrl} from 'services/firebase.js'//'../../../../../config/Firebase/firebase.config'

const auth = getAuth(app);

//--------------------------------------------
//get user
export const getUser = {
  onAuthStateChanged,
  auth
}/*(auth, (user) => {    
    // User is signed in, see docs for a list of available properties
    // https://firebase.google.com/docs/reference/js/firebase.User
    return user;    
    // ...
  });  */


/*or
const user = auth.currentUser;

if (user) {
  // User is signed in, see docs for a list of available properties
  // https://firebase.google.com/docs/reference/js/firebase.User
  // ...
} else {
  // No user is signed in.
}
*/


//create user with email
//import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
export const HandleCreateUserWithEmail = (values) => {
  console.log("HandleCreateUserWithEmail called with email:", values.email);
  console.log("Auth instance:", auth);
  return createUserWithEmailAndPassword(auth, values.email, values.password);
}


//sign in with email and password
//import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

export const HandlesignInWithEmail = (values) => {
  console.log("HandlesignInWithEmail called with email:", values.email);
  console.log("Auth instance:", auth);
  return signInWithEmailAndPassword(auth, values.email, values.password);
  /*.then((userCredential) => {
    // Signed in 
    const user = userCredential.user;
    // ...
  })
  .catch((error) => {
    //const errorCode = error.code;
    //const errorMessage = error.message;
    alert(`error logging in. Please try again. ${error}`);
  });*/
}

//-----------------------------------------------------
//get profile info
//https://firebase.google.com/docs/auth/web/manage-users#get_a_users_profile
export const HandleGetUserProfile = () => {
  const user = auth.currentUser;
  if (user !== null) {
    // The user object has basic properties such as display name, email, etc.
    const displayName = user.displayName;
    const email = user.email;
    const photoURL = user.photoURL;
    const emailVerified = user.emailVerified;
  
    // The user's ID, unique to the Firebase project. Do NOT use
    // this value to authenticate with your backend server, if
    // you have one. Use User.getToken() instead.
    const uid = user.uid;
    return {displayName, email, photoURL, emailVerified};
  }
}

//-----------------------------------------------------------------------
//update profile info
export const HandleUpdateProfile = (values) => {//displayName = '', email = '', photoURL = '', newPassword = '') => {
  const user = auth.currentUser;
  return updateProfile(auth.currentUser, {
    displayName: (values && values.name && values.name) || user.displayName, 
    photoURL: (values && values.photoURL && values.photoURL) || user.photoURL,
  });
}

export const HandleUpdateEmail = (email) => {
  if (email) {
    return updateEmail(auth.currentUser, email).then(() => {
      alert("Email updated!");
      // ...
    }).catch((error) => {
      // An error occurred
      // ...
      alert(`Error updating email. Please try again. ${error}`)
    })
  }
}
  
export const HandleUpdatePassword = (newPassword) => {
  if (newPassword) {   
    return updatePassword(auth.currentUser, newPassword).then(() => {
      // Update successful.
      alert("password updated!")
    }).catch((error) => {
      // An error ocurred
      // ...
      alert(`Error updating password! Please try again. ${error}`)
    });
  }
}
  

//for multiple profile
/**
 * import { getAuth } from "firebase/auth";

const auth = getAuth();
const user = auth.currentUser;

if (user !== null) {
  user.providerData.forEach((profile) => {
    console.log("Sign-in provider: " + profile.providerId);
    console.log("  Provider-specific UID: " + profile.uid);
    console.log("  Name: " + profile.displayName);
    console.log("  Email: " + profile.email);
    console.log("  Photo URL: " + profile.photoURL);
  });
}
 */


//reset password
export const HandleResetPassword = {sendPasswordResetEmail, auth}/*(email) => {
  sendPasswordResetEmail(auth, email)
  .then(() => {
    alert(`Password reset email sent! Check email to continue.`)
    // ..    
  })
  .catch((error) => {
    //const errorCode = error.code;
    //const errorMessage = error.message;
    // ..
    alert(`error resetting password. Please try again. ${error}`)
  });
}*/


//sign in with Google
export const HandleSignInWithGoogle = async () => {
  const provider = new GoogleAuthProvider();
  try {
    const result = await signInWithPopup(auth, provider);
    return result;
  } catch (error) {
    alert(error);
    throw error;
  }
}

//email verification
export const HandleEmailVerification = () => {
  sendEmailVerification(auth.currentUser)
  .then(() => {
    // Email verification sent!
    // ...
    alert("Email verification sent! Check your email to complete your authentication");
  });
}


//sign in with email link config
const actionCodeSettings = {
  // URL you want to redirect back to. The domain (www.example.com) for this
  // URL must be in the authorized domains list in the Firebase Console.
  url: `${baseUrl}/`,
  // This must be true.
  handleCodeInApp: true,
  /*iOS: {
    bundleId: 'com.example.ios'
  },
  android: {
    packageName: 'com.example.android',
    installApp: true,
    minimumVersion: '12'
  },
  dynamicLinkDomain: 'example.page.link'
  */
};

//---------------------------------------------------------------------------
//sign in with email logic
export const HandleSendSignInLinkToEmail = (email) => {  
  sendSignInLinkToEmail(auth, email, actionCodeSettings)
    .then(() => {
      // The link was successfully sent. Inform the user.
      // Save the email locally so you don't need to ask the user for it again
      // if they open the link on the same device.
      window.localStorage.setItem('emailForSignIn', email);
      //window.localStorage.setItem('userInfo', email);
      alert("Link successfully sent. Please check email for direction.");
      // ...
    })
    .catch((error) => {
      //const errorCode = error.code;
      //const errorMessage = error.message;
      alert(error);
      // ...
    }
  );
}


// Confirm the link is a sign-in with email link.
export const HandleSignInWithLink = () => {
  if (isSignInWithEmailLink(auth, window.location.href)) {
    // Additional state parameters can also be passed via URL.
    // This can be used to continue the user's intended action before triggering
    // the sign-in operation.
    // Get the email if available. This should be available if the user completes
    // the flow on the same device where they started it.
    let email = window.localStorage.getItem('emailForSignIn');
    if (!email) {
      // User opened the link on a different device. To prevent session fixation
      // attacks, ask the user to provide the associated email again. For example:
      email = window.prompt('Please provide your email for confirmation');
    }
    // The client SDK will parse the code from the link for you.
    signInWithEmailLink(auth, email, window.location.href)
      .then((result) => {
        // Clear email from storage.
        window.localStorage.removeItem('emailForSignIn');
        // You can access the new user via result.user
        // Additional user info profile not available via:
        // result.additionalUserInfo.profile == null
        // You can check if the user is new or existing:
        //result.additionalUserInfo.isNewUser
        return result;
      })
      .catch((error) => {
        // Some error occurred, you can inspect the code: error.code
        // Common errors could be invalid email and invalid or expired OTPs.
        //const errorCode = error.code;
        //const errorMessage = error.message;
        alert(error);
      }
    );
  }
}
  

//---------------------------------------------------------------------------
//sign out
export const HandleSignOut = {signOut, auth}/* () => {
  signOut(auth).then(() => {
    // Sign-out successful.
    window.prompt("You successfully signed out!!!");
  }).catch((error) => {
    // An error happened.
    //const errorCode = error.code;
    //const errorMessage = error.message;
    alert(error);
  });
}*/
